import api from "@/lib/axios";

export const settingsService={
    // get all settings
    getAllSettings: async () => {
        try{
            const response = await api.get("/settings");
            return response.data;
        } catch (error) {
            throw new Error("Failed to fetch settings: " + error.message);
        }
    },

    // create setting
    createSetting: async(settingData) => {
        try{
            const response= await api.post("/settings",settingData);
            return response.data;
        } catch (error) {
            throw new Error("Failed to create setting:" + error.message);
        }
    },

    // update setting
    updateSetting: async(key, settingData)=>{
        try{
            const response= await api.put(`/settings/${key}`, settingData);
            return response.data;
        } catch (error) {
            throw new Error("Failed to update setting:" + error.message);
        }
    },

    // delete setting
    deleteSetting: async(key) => {
        try{
            const response= await api.delete(`/settings/${key}`);
            return response.data;
        } catch (error) {
            throw new Error("Failed to delete setting:" + error.message);
        }
    }
}


